<div class="settings"><router-view></router-view></div>